import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const generateLeavePDF = ({ leaveData, name = 'All', selectedDateRange = '' }) => {
  try {
    const doc = new jsPDF('p', 'mm', 'a4');
    const margin = 10;
    const headerHeight = 20;
    const pageWidth = doc.internal.pageSize.getWidth();
    let currentY = margin;

    // Header
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text('Leave Summary Report', margin, currentY + 10);
    // 👇 Top-right: Show selected date range
    if (selectedDateRange) {
      const textWidth = doc.getTextWidth(selectedDateRange);
      doc.setFontSize(11);
      doc.setTextColor(80, 80, 80);
      doc.text(selectedDateRange, pageWidth - margin - textWidth, currentY + 10);
    }

    currentY += headerHeight;

    // Prepare Summary Table
    const summaryHeaders = [
      'Financial Year',
      'Leave Type',
      'Total Leave',
      'Leave Taken',
      'Remaining',
    ];
    const summaryRows = [];
    const totalsByYear = leaveData?.reduce((acc, item) => {
      const year = item.FINANCIAL_YEAR;
      if (!acc[year]) {
        acc[year] = { totalLeave: 0, taken: 0, remaining: 0 };
      }
      acc[year].totalLeave += item.TOTAL_LEAVE;
      acc[year].taken += item.TAKEN;
      acc[year].remaining += item?.TOTAL_LEAVE - item?.TAKEN;
      return acc;
    }, {});

    leaveData?.forEach((item, index) => {
      summaryRows.push([
        item.FINANCIAL_YEAR,
        item.LEAVE_TYPE,
        item.TOTAL_LEAVE.toString(),
        item.TAKEN.toString(),
        item.TOTAL_LEAVE - item.TAKEN.toString(),
      ]);

      const isLastItemForYear =
        index === leaveData.length - 1 || leaveData[index + 1]?.FINANCIAL_YEAR !== item.FINANCIAL_YEAR;

      if (isLastItemForYear && totalsByYear[item.FINANCIAL_YEAR]) {
        // console.log("remain", totalsByYear[item.FINANCIAL_YEAR].totalLeave - totalsByYear[item.FINANCIAL_YEAR].taken)
        summaryRows.push([
          `Total for ${item.FINANCIAL_YEAR}`,
          '-',
          totalsByYear[item.FINANCIAL_YEAR].totalLeave.toString(),
          totalsByYear[item.FINANCIAL_YEAR].taken.toString(),
          totalsByYear[item.FINANCIAL_YEAR].totalLeave - totalsByYear[item.FINANCIAL_YEAR].taken
        ]);
      }
    });

    autoTable(doc, {
      head: [summaryHeaders],
      body: summaryRows,
      startY: currentY,
      columnStyles: {
        2: { halign: 'center' }, // Total Leave
        3: { halign: 'center' }, // Taken
        4: { halign: 'center' }, // Remaining
      },
    });

    currentY = doc.lastAutoTable.finalY + 10;

    // Prepare Detailed Leave Table
    const detailHeaders = [
      'Employee Name',
      'Financial Year',
      'Leave Type',
      'Leave Date',
      // 'Remarks',
    ];

    const detailRows = leaveData?.flatMap((item) =>
      item?.LEAVE_DATES?.split(',')?.map((dateStr) => {
        const trimmed = dateStr?.trim?.() || '';
        // const match = trimmed.match(/^([^\(]+)\s*(\(.*\))?$/);
        const match = trimmed.match(/^([^(]+)\s*\(?([^)]*)\)?$/);

        const date = match ? match[1]?.trim() : trimmed;
        const remarks = match && match[2] ? match[2].slice(1, -1) : '';
        return [
          item.EMPLOYEE_NAME,
          item.FINANCIAL_YEAR,
          item.LEAVE_TYPE,
          date,
          // remarks,
        ];
      }) || [] // fallback if LEAVE_DATES is null or not a string
    ) || [];

    const sortedDetailRows = detailRows?.sort((a, b) => {
      const dateA = new Date(a[3]);
      const dateB = new Date(b[3]);
      return dateA - dateB;
    });
    autoTable(doc, {
      head: [detailHeaders],
      body: sortedDetailRows,
      startY: currentY,
    });

    // Save file
    doc.save(`Leave_Report_${name}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default generateLeavePDF;
